module.exports = __webpack_public_path__ + "static/media/test6_name_customcolor_backless_v2_light.05f23bf6.png";